<template>
  <div class="loading-overlay" v-if="loading">Loading...</div>
  <div v-if="!loading" class="account-detail-container">
    <h2>Account Details</h2>

    <div class="account-card">
      <p style="font-size: large">
        <strong>Account Name:</strong> {{ account.account_name }}
      </p>
      <p style="font-size: large">
        <strong>Account Type:</strong> {{ account.account_type }}
      </p>
      <p style="font-size: 1.5em">
        <strong>Balance:</strong> Ksh. {{ formatCurrency(account.balance) }}
      </p>
    </div>

    <div class="actions">
      <a
        :href="'/finance/account_statement/' + account_id"
        class="action-button"
      >
        📄 View Statement
      </a>
      <button class="action-button" @click="show_deposit_pop">
        💰 Deposit
      </button>
      <button class="action-button" @click="show_withdrawal_pop">
        💸 Withdraw
      </button>
      <button class="action-button" @click="showTransferModal = true">
        🔁 Transfer Funds
      </button>
    </div>

    <!-- Withdraw Modal -->
    <div v-if="showWithdrawModal" class="modal-overlay">
      <div class="modal">
        <h3>Withdraw Funds</h3>
        <input
          type="number"
          v-model="transactionAmount"
          placeholder="Enter amount"
        />
        <button class="action-button" @click="withdraw">
          Confirm Withdrawal
        </button>
        <button class="cancel-button" @click="showWithdrawModal = false">
          Cancel
        </button>
      </div>
    </div>

    <!-- Transfer Modal -->
    <div v-if="showTransferModal" class="modal-overlay">
      <div class="modal">
        <h3>Transfer Funds</h3>
        <input
          type="number"
          v-model="transactionAmount"
          placeholder="Enter amount"
        />
        <input
          type="text"
          v-model="destinationAccount"
          placeholder="Destination Account ID"
        />
        <button class="action-button" @click="transfer">
          Confirm Transfer
        </button>
        <button class="cancel-button" @click="showTransferModal = false">
          Cancel
        </button>
      </div>
    </div>
  </div>
  <deposite_modal
    @close-deposit-modal="hide_deposit_pop"
    transaction_details="Deposit into Account"
    :account_id="account_id"
    v-if="show_deposit_modal"
  />

  <withdrawal_modal
    v-if="showWithdrawalModal"
    :account_id="account_id"
    @close-withdrawal-modal="close_withdrawal_pop"
    transaction_details="Withdrawal from Account"
  />

  <transfer_funds_modal
    v-if="showTransferModal"
    :account_id="account_id"
    @close-funds-transfer-modal="close_transfer_pop"
    transaction_details="Transfer from Account to "
  />
</template>

<script>
import deposite_modal from "./modals/deposite_modal.vue";
import transfer_funds_modal from "./modals/transfer_funds_modal.vue";
import withdrawal_modal from "./modals/withdrawal_modal.vue";
import { generalApiRequest } from "../../api/apiIndex";
export default {
  data() {
    return {
      account: {
        account_name: "Loading...",
        account_id: "",
        account_type: "",
        balance: 0,
      },
      showWithdrawalModal: false,
      show_deposit_modal: false,
      account_id: this.$route.params.accountID,
      transactionAmount: 0,
      destinationAccount: "",
      showDepositModal: false,
      showWithdrawModal: false,
      showTransferModal: false,
      loading: false,
    };
  },
  components: {
    deposite_modal,
    withdrawal_modal,
    transfer_funds_modal,
  },
  mounted() {
    this.fetchAccountDetails();
    // this.fetchAccountDetails();
  },
  methods: {
    show_transfer_pop() {
      this.showTransferModal = true;
    },
    close_transfer_pop() {
      this.showTransferModal = false;
      this.fetchAccountDetails();
    },
    show_withdrawal_pop() {
      this.showWithdrawalModal = true;
    },
    close_withdrawal_pop() {
      this.showWithdrawalModal = false;
      this.fetchAccountDetails();
    },
    show_deposit_pop() {
      this.show_deposit_modal = true;
    },
    hide_deposit_pop() {
      this.show_deposit_modal = false;
      this.fetchAccountDetails();
    },
    async fetchAccountDetails() {
      this.loading = true;
      var req_body = {};
      const url = `get_company_account_by_id/` + this.account_id;
      const res = await generalApiRequest(url, "GET", req_body, 1);
      console.log(res);

      this.account = res.data;
      this.loading = false;
    },
    formatCurrency(value) {
      return parseFloat(value).toLocaleString();
    },
    viewStatement() {
      this.$router.push(`/account_statement/${this.account.account_id}`);
    },
  },
};
</script>

<style scoped>
.account-detail-container {
  max-width: 800px;
  margin: 30px auto;
  padding: 25px;
  background: #fdfdfd;
  border-radius: 12px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}

.account-card {
  background: #ffffff;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 25px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
}

.action-button {
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  background: #009688;
  color: #fff;
  cursor: pointer;
  transition: 0.2s;
}

.action-button:hover {
  background: #00796b;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal {
  background: #fff;
  padding: 25px;
  border-radius: 10px;
  width: 350px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.modal h3 {
  margin-bottom: 15px;
}

.modal input {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.cancel-button {
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  background: #e53935;
  color: #fff;
  cursor: pointer;
  transition: 0.2s;
  margin-left: 10px;
}

.cancel-button:hover {
  background: #c62828;
}
.loading-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh; /* assumes parent div has a height */
  background-color: #fff;
  font-size: 1.9em;
  font-weight: bold;
  color: #333;
}
</style>
